import React from "react";
import { Link } from "react-router-dom";

const SignInFooterLink = ({ styleClass }: any) => {
	return (
		<div className={styleClass}>
			Are you a already a user? &nbsp;
			<span className="link-container">
				<Link className="sign-in-link" to="/login">
					Sign in
				</Link>
			</span>
		</div>
	);
};

export default SignInFooterLink;
